import Vue from "vue";
import VueRouter from "vue-router";

//expatcare.co.kr, www.expatcare.co.kr 도메인인 경우.

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/relocation/ReLocation.vue"),
    // alias: ["/apply"],
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact",
    component: () => import("@/relocation/ReLocationContact.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact-02/:idx",
    component: () => import("@/relocation/ReLocationContact_02.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    name: "re-location-contact-03",
    path: "/re-location-contact-03/:regid",
    component: () => import("@/relocation/ReLocationContact_03.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact-04",
    component: () => import("@/relocation/ReLocationContact_04.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
];

const expatcare = new VueRouter({
  mode: "history",
  routes,
});

expatcare.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotGlobal" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default expatcare;
